// extracted by mini-css-extract-plugin
export default {"editor":"CommentCreate-module__editor--mBbhg","container":"CommentCreate-module__container--YsQ8S"};